import React from 'react'
import Input from '../DMGComponents/Input'
import Break from '../DMGComponents/Break'
import Button from '../DMGComponents/Button'
import { createUser } from '../fetchData';
import { isDMGUser } from '../authProvider';
import toast, { Toaster } from 'react-hot-toast';
import FileExLogo from '../components/FileExLogo';
import { withRouter } from 'react-router-dom';
import { validateEmail } from '../utils/helperFunctions';

class CreateUser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth,
            firstName: "",
            lastName: "",
            company: "",
            email: "",
            lengthValidation: "You must enter at least 2 characters.",
            emailValidation: "You must enter a vaild email address.",
            validationError: "",
            selectedAreaId: this.props.location.state.areaId
        }

        this.firstNameChanged = this.firstNameChanged.bind(this);
        this.lastNameChanged = this.lastNameChanged.bind(this);
        this.companyChanged = this.companyChanged.bind(this);
        this.emailChanged = this.emailChanged.bind(this);
    }

    firstNameChanged = (value) => {
        if (value.length < 2) {

        }
        this.setState({
            firstName: value
        })
    }

    lastNameChanged = (value) => {
        this.setState({
            lastName: value
        })
    }

    companyChanged = (value) => {
        this.setState({
            company: value
        })
    }

    emailChanged = (value) => {
        this.setState({
            email: value
        })
    }

    cancel = () => {
        this.props.history.push({
            pathname: '/',
            state: {
                areaId: this.state.selectedAreaId
            }
        })
    }
    createUser = () => {
        this.setState({
            validationError: ""
        })
        if (this.state.firstName.length > 1 && this.state.lastName.length > 1 && this.state.company.length > 1 && this.state.email.length > 1) {
            if (validateEmail(this.state.email)) {
                createUser(this.state.selectedAreaId, { firstName: this.state.firstName, lastName: this.state.lastName, email: this.state.email, company: this.state.company }).then(() => {
                    this.props.history.push({
                        pathname: '/',
                        state: {
                            areaId: this.state.selectedAreaId,
                            userCreated: true
                        }
                    })
                }).catch((err) => {
                    console.error("Error", err);
                    toast.error("Error creating user. " + err)
                })
            }
            else {
                this.setState({
                    validationError: "Please enter a valid email address."
                })
            }
        }
        else {
            this.setState({
                validationError: "Please fill out all fields."
            })
        }
    }

    render() {
        return (
            <div>
                <FileExLogo clicked={() => {
                    this.props.history.push({
                        pathname: '/'
                    })
                }} />
                {isDMGUser() &&
                    <div>
                        <Toaster />
                        <Break style={{ margin: "20px 0" }}>
                            Create User
                        </Break>
                        <div className="ca">
                            {this.state.validationError.length > 0 &&
                                <label style={{ color: "#F50506" }}>{this.state.validationError}</label>
                            }
                            <Input label="First name" value={this.state.firstName} onClick={this.firstNameChanged} />
                            <Input label="Last name" value={this.state.lastName} onClick={this.lastNameChanged} />
                            <Input label="Company" value={this.state.company} onClick={this.companyChanged} />
                            <Input label="Email" value={this.state.email} onClick={this.emailChanged} />
                    </div>
                    <div style={{ display: "flex", justifyContent: "left", float: "left" }}>
                        <Button type="hover-bottom-left" onClick={this.cancel}>Cancel</Button>
                    </div>
                    <div style={{ display: "flex", justifyContent: "right", float: "right" }}>
                        <Button type="hover-bottom-left" onClick={this.createUser}>Create</Button>
                    </div>
                </div>
                }
            </div>
        );
    }
}
export default withRouter(CreateUser);